import { NotificationReceived } from './../../models/notifications.model';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, from } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Store } from '@ngxs/store';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { take, map, mergeMap } from 'rxjs/operators';
import * as arrow from '@apache-arrow/esnext-umd';

const { Table } = arrow;
const enc = new TextEncoder();
@Injectable()
export class PushNotificationService {
  constructor(private store: Store, private http: HttpClient) {
    const omnibus = new BroadcastChannel('omnibus');
    omnibus.addEventListener('message', event => {
      const tableau = Table.from(event.data)
      /* Usage:
        Access topic: tableau.schema.metadata.get('topic')
        Access data: [...tableau] or for (const row of tableau) {}
        Note: UUIDs are stored in binary form, as Uint8Arrays
      */
      this.store.dispatch(new NotificationReceived(tableau));
    })
  }
  subscribeToTopic({topic}): Observable<any> {
    const {subscriptionHash} = this.store.selectSnapshot((state) => state.push_notifications);
    return this.http.post(`${environment.webPushBrokerUrl}/device/subscribe`, {topic, subscription_hash: subscriptionHash});
  }
  unsubscribeFromTopic({topic}): Observable<any> {
    const {subscriptionHash} = this.store.selectSnapshot((state) => state.push_notifications);
    return this.http.post(`${environment.webPushBrokerUrl}/device/unsubscribe`, {subscription_hash: subscriptionHash, topic});
  }
  async internalDeregisterDevice() {
    const sw = await navigator.serviceWorker.getRegistration();
    const subscription = sw ? await sw.pushManager.getSubscription() : null;
    if (subscription) {
      await subscription.unsubscribe();
    }
  }
  async deregisterDevice() {
    const { username : email, authenticated } = this.store.selectSnapshot(state => state.auth);
    let {subscriptionHash} = this.store.selectSnapshot(state => state.push_notifications);
    if(!subscriptionHash) {
      const sw = await navigator.serviceWorker.getRegistration();
      if(sw) subscriptionHash = await this.computeSubscriptionHash(JSON.stringify((await sw.pushManager.getSubscription())));
    }
    await this.internalDeregisterDevice();
    if(!authenticated) {
      return;
    }
    return subscriptionHash ? this.http.post(`${environment.webPushBrokerUrl}/device/unregister`, { subscription_hash: subscriptionHash, email }).toPromise() : true
  }

  async checkSubscription() {
    const sw = await navigator.serviceWorker.getRegistration();
    if(!sw) {
      return false;
    }
    return !!(await sw.pushManager.getSubscription())
  }

  async requestPermission() {
    const sw = await navigator.serviceWorker.getRegistration();
    if(!sw) {
      return false;
    }
    return Notification.requestPermission();
  }

  async computeSubscriptionHash(subscriptionJSON) {
    const digestBuf = await crypto.subtle.digest('SHA-256', enc.encode(subscriptionJSON).buffer);
    const subscriptionHash =  btoa(String.fromCharCode(...new Uint8Array(digestBuf)))
    return subscriptionHash;
  }

  async checkRemoteDeviceRegistration() {
    const {subscriptionHash} = this.store.selectSnapshot(state => state.push_notifications);
    const authenticated = this.store.selectSnapshot(state => state.auth.authenticated);
    if(!authenticated) return;
    const deviceRegistration = await this.http.get(`${environment.webPushBrokerUrl}/device/registrations/get`, { params: { subscription_hash: subscriptionHash } }).toPromise();
    console.log(deviceRegistration)
    return !!deviceRegistration
  }

  async registerDevice() {
    const {username : email, authenticated } = this.store.selectSnapshot(state => state.auth);
    if(!authenticated) return false;
    const applicationServerKey = await this.http.get(`${environment.webPushBrokerUrl}/getPublicKey`, {responseType: 'arraybuffer'}).toPromise()
    const sw = await navigator.serviceWorker.getRegistration();
    // ensure that we don't already have a subscription, and transparently pass the existing one if we do
    const subscription = JSON.stringify((await sw.pushManager.getSubscription()) || (await sw.pushManager.subscribe({
      applicationServerKey, userVisibleOnly: true
    })));
    await this.http.post(`${environment.webPushBrokerUrl}/device/register`, { email, subscription}).toPromise();
    console.log('successfully registered')
    const hash = await this.computeSubscriptionHash(subscription)
    console.log(hash)
    return hash
  }

  public sendInAppNotification(data):any {
    const options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    const webPushBrokerApiUrl = environment.webPushBrokerUrl + '/gapmaps/notification/create';

    return this.http.post(`${webPushBrokerApiUrl}` , data ,options);
  }
  public getAllNotificationTypes():any {
    const options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    const webPushBrokerApiUrl = environment.webPushBrokerUrl + '/gapmaps/notification/types/getall';

    return this.http.get(`${webPushBrokerApiUrl}`, options);
  }
}
